import { getToFixed } from 'helpers/index';

export const writeMarginOfError = (margin: number | null) => {
	const fixedMargin = getToFixed(margin);
	return fixedMargin ? `+/-${fixedMargin}` : fixedMargin;
};

export const displayData = (data: null | number) => data?.toString() || '—';
